module.exports = __webpack_public_path__ + "img/exit-icon.38329b80.svg";